import { render, staticRenderFns } from "./ModalitiesPopover.vue?vue&type=template&id=197bf2fe&scoped=true"
import script from "./ModalitiesPopover.vue?vue&type=script&lang=js"
export * from "./ModalitiesPopover.vue?vue&type=script&lang=js"
import style0 from "./ModalitiesPopover.vue?vue&type=style&index=0&id=197bf2fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197bf2fe",
  null
  
)

export default component.exports